module.exports = __webpack_public_path__ + "static/media/parking.83a13838.png";